import { func, shape, string } from 'prop-types'
import React from 'react'

class Venue extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      isVisible: false,
    }
  }
  handleMouseOut = () => {
    this.setState({
      isVisible: false,
    })
  }
  handleMouseOver = () => {
    this.setState({
      isVisible: true,
    })
  }
  render() {
    if (this.props.venue === null) {
      return (
        <div className={`venue is-disabled ${this.props.which.toLowerCase()}`}>
          <div className="venue-inner">
            <div className="trigger">
              {this.props.which}
            </div>
          </div>
        </div>
      )
    }
    return (
      <div className={`venue ${this.props.which.toLowerCase()}`}>
        <div className="venue-inner">
          <a
            className="trigger"
            href={this.props.venue.url}
            onClick={this.props.onClick}
            onMouseOut={this.handleMouseOut}
            onMouseOver={this.handleMouseOver}
          >
            {this.props.which}
          </a>
          {this.state.isVisible &&
            <div className="tooltip">
              <div className="image-container">
                <div className="image">
                  <img src={this.props.venue.image} />
                </div>
              </div>
              <div className="info">
                <div className="site-building">
                  {this.props.venue.site_building}
                </div>
                <div className="venue-name">{this.props.venue.name}</div>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}
Venue.defaultProps = {
  venue: null,
}
Venue.propTypes = {
  onClick: func.isRequired,
  venue: shape({
    image: string,
    name: string.isRequired,
    site_building: string.isRequired,
    url: string.isRequired,
  }),
  which: string.isRequired,
}

export default Venue
